import { Component, OnInit, OnDestroy, AfterViewInit, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NewsService } from '../../services/news.service';
import { LearningService } from 'src/app/services/learning.service';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import {Location} from '@angular/common';
import 'dotdotdot-js'
@Component({
  selector: 'app-learning-detail',
  templateUrl: './learning-detail.component.html',
  styleUrls: ['./learning-detail.component.scss']
})
export class LearningDetailComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChildren('insertDotdotdot') insertDotdotdot: QueryList<ElementRef>
  language = JSON.parse(localStorage.getItem('language'))

  private learning: any

  showLearning: any
  learningTitle: string
  learningDate: string

  pageHeaderStyle = {}
  detail:any;
  learningType: string
  pdfUrl: any

  file_pdf: any
  pdfUrl_path: any
  id: any
  filesize: any;

  backgroundPath = 'assets/images/lead/default@2x.png'

  flag: any

  constructor(
    private route: ActivatedRoute,
    private _newsService: NewsService,
    private _learningService: LearningService,
    private _sanitizer: DomSanitizer,
    private location: Location,
  ) { }

  ngOnInit() {
    this.flag = localStorage.getItem("language_flag")

    this.learning = this.route.params.subscribe(params => {
      this._learningService.getLearningByID(params['id']).subscribe(response => {

        if (this.flag == 'th') {
        if (response[0].learning_type === 'text') {
          this.file_pdf = 'no'
          response[0].detail = this.htmlTransforms(response[0].detail)
          this.showLearning = response
          this.learningTitle = response[0].title
          this.learningType = response[0].learning_type
          this.learningDate = this._newsService.date_thai(response[0].publicdate)
        } else if (response[0].learning_type === 'image') {
          this.file_pdf = 'no'
          this.showLearning = response
          this.learningTitle = response[0].title
          this.learningType = response[0].learning_type
          this.learningDate = this._newsService.date_thai(response[0].publicdate)
        } else if (response[0].learning_type === 'pdf') {
          this.file_pdf = 'yes'
          this.pdfUrl_path = response[0].detail
          this.showLearning = response
          this.pdfUrl = this.urlTransform(response[0].detail)
          this.learningTitle = response[0].title
          this.learningType = response[0].learning_type
          this.filesize = response[0].filesize
          this.learningDate = this._newsService.date_thai(response[0].publicdate)
        }
        else  if (response[0].learning_type == 'vdo') {
          this.file_pdf = 'no';
          this.showLearning = response;
          this.detail = response[0].detail;
          this.id =  response[0].detail;
          this.learningTitle = response[0].title;
          this.learningType = response[0].learning_type;
          this.learningDate = this._newsService.date_thai(response[0].publicdate)
        }
      } else {
          if (response[0].learning_type === 'text') {
            this.file_pdf = 'no'
            response[0].detail_en = this.htmlTransforms(response[0].detail_en)
            this.showLearning = response
            this.learningTitle = response[0].title_en
            this.learningType = response[0].learning_type
            this.learningDate = response[0].publicdate;
          } else if (response[0].learning_type === 'image') {
            this.file_pdf = 'no'
            this.showLearning = response
            this.learningTitle = response[0].title_en
            this.learningType = response[0].learning_type
            this.learningDate = response[0].publicdate;
          } else if (response[0].learning_type === 'pdf') {
            this.file_pdf = 'yes'
            this.pdfUrl_path = response[0].detail_en
            this.showLearning = response
            this.pdfUrl = this.urlTransform(response[0].detail_en)
            this.learningTitle = response[0].title_en
            this.learningType = response[0].learning_type
            this.filesize = response[0].filesize
            this.learningDate = response[0].publicdate;
          }
          else  if (response[0].learning_type == 'vdo') {
            this.file_pdf = 'no';
            this.showLearning = response;
            this.detail = response[0].detail_en;
            this.id =  response[0].detail_en;
            this.learningTitle = response[0].title_en;
            this.learningType = response[0].learning_type;
            this.learningDate = response[0].publicdate;
          }

        }
      })
    })

    this.pageHeaderStyle = {
      'background-image': 'url(' + this.backgroundPath + ')',
      'height': `360px`,
    }
  }

  ngAfterViewInit() {
    this.insertDotdotdot.changes.subscribe(() => {
      this.insertDotdotdot.toArray().forEach(el => {
        $(el.nativeElement).dotdotdot({
          truncate: "letter",
          watch: true,
        })
      })
    })
  }

  ngOnDestroy() {
    this.learning.unsubscribe();
  }
  

  htmlTransforms(value: string): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(value)
  }

  urlTransform(value): SafeResourceUrl {
    return this._sanitizer.bypassSecurityTrustResourceUrl(value)
  }

  back(){
    this.location.back()
  }
}
